// extracted by mini-css-extract-plugin
module.exports = {"complete-pane":"complete-pane__jt6qn","header":"header__Q0kiR","text":"text__2SeP_","button-wrapper":"button-wrapper__16cpm","button":"button__3saEq"};